import ListenToKeyboard from 'components/ListenToKeyboard'
import { connect } from 'react-redux'
import { doShowHotkeysModal } from 'ducks/modals/hotkeys'
import { doAssignCurrentOrSelectedRoomsToCurrentUser } from 'ducks/chat/actions/rooms'

const select = () => ({
  preventDefault: true,
  disableForInput: true,
})

const perform = {
  onShiftForwardSlash: doShowHotkeysModal,
  onG: doAssignCurrentOrSelectedRoomsToCurrentUser,
}

export default connect(select, perform)(ListenToKeyboard)
